import * as React from 'react';
import { useNavigate } from 'react-router';
import { Grid, Typography } from '@mui/material';
import { MissingPhoto } from 'Interfaces/IGlobalTypeConfig';
import CustomAvatar from '../../../components/ui/customAvatar';
import { t } from 'i18next';

export const SingleOrderEmployeeView = (props: any) => {
  const employee = props.employee;
  console.log('SingleOrderEmployeeView - employee:', employee); // Debug log
  return (
    <Grid
      item
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'primary.lighter',
      }}
    >
      <Grid
        item
        sx={{
          width: 88,
          borderRadius: 2,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        {employee?.url ? (
          <img
            src={employee?.url || MissingPhoto.COMPANY_URL}
            style={{
              padding: 0,
              width: 88,
              height: 88,
              objectFit: 'scale-down',
            }}
            alt={'logo'}
          />
        ) : (
          <CustomAvatar
            avatarName={employee?.name || ''}
            imgWidth={88}
            imgHeight={88}
          />
        )}
      </Grid>
      <Grid item sx={{ flexGrow: 1, backgroundColor: 'primary.dark' }}>
        <Grid container sx={{ pl: 1 }}>
          <Grid item xs={12} sx={{ m: 0, p: 0 }}>
            <Typography
              sx={{
                m: 0,
                p: 0,
                pl: 1,
                letterSpacing: 1,
                textAlign: 'left',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
                fontSize: 18,
              }}
            >
              {employee?.name}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ m: 0, p: 0 }}>
            <Typography
              sx={{
                m: 0,
                p: 0,
                pl: 1,
                letterSpacing: 1,
                textAlign: 'left',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
                fontSize: 16,
                color: 'secondary.text',
              }}
            >
              {employee?.phone || 'No phone'}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ m: 0, p: 0 }}>
            <Typography
              sx={{
                m: 0,
                p: 0,
                pl: 1,
                letterSpacing: 1,
                textAlign: 'left',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontWeight: 'normal',
                fontSize: 16,
              }}
            >
              {employee?.email || 'No email'}
            </Typography>
          </Grid>
       
        </Grid>
      </Grid>
    </Grid>
  );
};
